import React from 'react'
import {QuoteDetailListTable} from "../Component/QuoteDetailListTable";

const ApprovedTabList = (props) => {
    return (
        <div>
            <QuoteDetailListTable {...props}/>
        </div>
    )
};

export default ApprovedTabList